import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { entityOnBoardReport } from './action';
import { 
  ResponsiveContainer, 
  BarChart, 
  CartesianGrid, 
  XAxis, 
  YAxis, 
  Tooltip, 
  Legend, 
  Bar 
} from 'recharts';
import { Typography, Card, CardContent, CircularProgress, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import { Col, Row } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: 'auto',
    marginTop: theme.spacing(5),
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
  },
}));

const PartnerDashboard = (props) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoomIn, setZoomIn] = useState(true); // Initially zoom in
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const result = await dispatch(entityOnBoardReport());
    setData(result);
    setLoading(false);
  };

  const handleZoomClick = () => {
    if (zoomIn) {
      props.onZoomClick("PartnerDashboard");
    } else {
      props.onZoomClick("zoom");
    }
    setZoomIn(!zoomIn); // Toggle between zoom in and zoom out
  };

  return (
    <Card variant="outlined" className={classes.card} style={{maxWidth:"100%"}}>
      <CardContent className={classes.cardContent}>
      <Row>
                                    <Col>
                                        <Typography variant="h5" component="div" className={classes.chartTitle}>
                                        Partner Data
                                        </Typography>
                                    </Col>
                                    <Col style={{display:"flex",justifyContent:"end"}}>
                                        <IconButton
                                            color="primary"
                                            className={classes.button}
                                            onClick={handleZoomClick}
                                        >
                                            {zoomIn ? <ZoomInIcon /> : <ZoomOutIcon />}
                                        </IconButton>
                                    </Col>
                                </Row>
        
        {loading ? (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        ) : (
          <>
            
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar 
                  dataKey="entity_count"
                  barSize={15}
                  radius={[10, 10, 0, 0]}
                  fill="#8884d8" 
                />
              </BarChart>
            </ResponsiveContainer>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default PartnerDashboard;
